import Gator from 'gator';

Gator(document).on('click', '.-live [data-href]', function () {
    const href = this.dataset.href;
    if (href) {
        window.location = href;
    }
});
